import { writable } from 'svelte/store';
export var AuthStore;
(function (AuthStore) {
    // export let user = null;
    AuthStore.user = writable(null);
    function login(value) {
        AuthStore.user.set(value);
        // console.log('user', user);
        if (value != null) {
            AuthStore.authStatus.set(AuthStatusType.authorized);
        }
        else {
            AuthStore.authStatus.set(AuthStatusType.unAuthorized);
        }
    }
    AuthStore.login = login;
    function logout() {
        AuthStore.user.set(null);
    }
    AuthStore.logout = logout;
    // export const isLoading = writable<boolean>(false);
    //
    // export function setIsLoading(value: boolean) {
    //     isLoading.set(value);
    // }
    let AuthStatusType;
    (function (AuthStatusType) {
        AuthStatusType[AuthStatusType["undefined"] = 0] = "undefined";
        AuthStatusType[AuthStatusType["authorized"] = 10] = "authorized";
        AuthStatusType[AuthStatusType["unAuthorized"] = 20] = "unAuthorized";
    })(AuthStatusType = AuthStore.AuthStatusType || (AuthStore.AuthStatusType = {}));
    AuthStore.authStatus = writable(AuthStatusType.undefined);
    // export let authStatus: AuthStatusType = AuthStatusType.undefined;
})(AuthStore || (AuthStore = {}));
